
if (!customElements.get('cbn-sale-popup')) {
  customElements.define('cbn-sale-popup', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const trigger = this.querySelector('[data-offer-open]');
      const dialog = this.querySelector('dialog');
      let chooseVariant = false;
      const close = () => dialog.close();
      this.querySelector('[data-offer-choose]')?.addEventListener('click', () => {
        chooseVariant = true;
        close();
      }, options);
      trigger.addEventListener('click', () => {
        dialog.showModal();
        document.documentElement.classList.add('cbn-sale-open');
      }, options);
      this.querySelector('[data-offer-close]').addEventListener('click', close, options);
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
      }, options);
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cbn-sale-open');
        trigger.focus({ preventScroll: true });
        if (chooseVariant) {
          chooseVariant = false;
          const picker = this.closest('.product-details')?.querySelector('variant-picker, variant-main-picker, .variant-picker');
          if (picker) {
            picker.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
            const input = picker.querySelector('input:not([disabled]):not([type="hidden"]), select:not([disabled])') || picker.querySelector('button:not([disabled])');
            input?.focus({ preventScroll: true });
          }
        }
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      if (this.querySelector('dialog')?.open) document.documentElement.classList.remove('cbn-sale-open');
    }
  });
}
